<template>
    <div class="service-charge-wrap bg-white pt-20 pb-20">
        <div class="container">
            <div class="row pt-50">
                 <div class="col-lg-6">
                    <div class="card">
                        <div class="card-body ">
                            <img src="../../assets/images/accueil.png" alt="Image"
                                style="width: 100%; height: auto; object-fit: contain" />
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="section-title mb-40">
                        <span>Bienvenue à</span>
                        <h2 class="">L'École d’Initiation Théologique et Pastorale</h2>
                    </div>
                    <p class="text-justify"
                        style="text-align: justify; text-justify: inter-word; font-size: 16px; color: #000000;">
                        L’École d’Initiation Théologique et Pastorale (EITP).

                        Un cadre d’approfondissement de la foi à travers une formation intégrale en cinq axes : Bible;
                        Théologie; Histoire des Pères et de l’Église; Vie de foi et Culture Générale…

                        Un foyer incandescent de réflexion intellectuelle où au-delàs des activités académiques
                        s’organisent des activités intellectuelles paracadémiques, le tout nourri et porté par une
                        remarquable lymphe spirituelle;

                        Une dynamique de créativité au nom de la foi, et de pastorale ouverte sur le monde;

                        L’EITP, c’est une vie, et au-delàs des cours, c’est un parcours de vie.
                    </p>
                </div>

               
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { ref, watch } from 'vue';
import Multiselect from '@vueform/multiselect';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from "../../services/ApiService";
import axios from 'axios';
import { error, success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import * as Yup from "yup";
import { eventBus } from '@/utils/redirection';

export default {
    name: 'ChargeCalculator',
    components: {

    },
    setup: () => {

        const estimationSchema = Yup.object().shape({
            type: Yup.string().required('Le type d\'envoi est obligatoire'),
            poids: Yup.number().typeError("Entrez un poids valide").required('Le poids est obligatoire'),
            distance: Yup.string().required("La distance est obligatoire"),
        });

        const distanceOptions = ref([]);
        const distanceSelect = ref([]);
        const typeValue =
            [
                {
                    value: 1,
                    label: "Colis postaux"
                },
                {
                    value: 2,
                    label: "Envois express"
                },
                {
                    value: 3,
                    label: "Poste aux lettres"
                },
                {
                    value: 4,
                    label: "Transport de colis/marchandises et Location de bus/camions"
                }
            ];
        const router = useRouter();

        function typeChange(value) {
            if (value) {
                distanceOptions.value = [];
                distanceSelect.value = []
                ApiService.get('/distance/type/' + value)
                    .then(({ data }) => {
                        const donnee = data.data;
                        if (donnee.length > 0) {
                            distanceOptions.value = donnee.map((distance: any) => {
                                return {
                                    label: distance.libelle + ':' + '' + distance.distance,
                                    value: distance.id,
                                };
                            });
                        }
                    })
                    .catch(({ response }) => {
                        //error(response.data.message);
                    });
            } else {
                distanceOptions.value = [];
                distanceSelect.value = [];
            }
        }

        const montant = ref();
        const distance = ref();
        const poids = ref();
        const type = ref();
        const checkEstimation = async (values) => {
            console.log('offvale', values)
            //   ApiService.post("/montantEstimations", values)
            ApiService.post("/montantEstimations", values)
                .then(({ data }) => {
                    montant.value = data.montant.montant;
                    distance.value = data.distanceEntity.libelle + " : " + data.distanceEntity.distance;
                    type.value = data.distanceEntity.type;
                    poids.value = data.getPoids;
                    console.log('estimation', montant.value);
                    console.log('distance', distance.value);
                    console.log('poids', type.value);
                    console.log('type', poids.value);
                    //   if (data.code == 201) {
                    //     success(data.message);
                    //     //resetForm();
                    //     //router.push({ name: "ListeProduitPage" });
                    //   }
                })
                .catch(({ response }) => {
                    error(response.data.message);
                });
        };

        // const showSimulation = ref(eventBus.showSimulation);

        // watch(eventBus, (newVal) => {
        //   showSimulation.value = newVal.showSimulation;
        //   console.log('charge', showSimulation.value);
        // });

        return {
            typeValue,
            distanceOptions,
            typeChange,
            distanceSelect,
            estimationSchema,
            checkEstimation,
            montant, distance,
            poids, type,
        }
    }
}
</script>
